<template>
  <div>
    <div
      @drop="onDrop($event, 1)"
      @dragover.prevent
      @dragenter.prevent
      :class="{
        'basemap-fix': !sidebarHasOpened && $vuetify.breakpoint.mdAndUp,
      }"
      id="viewDiv"
      class="balt-theme"
      style="left: 0px; bottom: 0px; overflow: hidden"
    >
      <div class="map-center-dummy" data-v-step="intro"></div>
      <div class="map-corner-dummy" data-v-step="123"></div>
      <div class="map-corner-dummy" data-v-step="124"></div>
      <div class="map-center-dummy" data-v-step="infowindow"></div>

      <div class="map-corner-dummy" data-v-step="menu"></div>

      <div class="map-center-dummy" data-v-step="navigation"></div>
      <div class="map-center-dummy" data-v-step="extent"></div>
      <div class="map-center-dummy" data-v-step="final"></div>
      <div>
        <div
          class="basemap-menu-hidden"
          :class="[
            {
              'controls-bottom-bar-hidden': !tools.coordinates.active,
              'controls-bottom-bar-visible': tools.coordinates.active,
            },
          ]"
          style="position: absolute; z-index: 0"
        >
          <map-basemap-select
            data-v-step="2"
            v-if="viewloaded && $vuetify.breakpoint.mdAndUp"
          />
        </div>

        <v-fade-transition>
          <div
            v-if="viewloaded"
            v-show="!popupVisible || $vuetify.breakpoint.smAndUp"
            style="position: absolute; right: 10px;"
            :class="[
              {
                'controls-bottom-bar-hidden': !tools.coordinates.active,
                'controls-bottom-bar-visible': tools.coordinates.active,
              },
            ]"
          >
            <v-layout align-center justify-center column>
              <map-buildings-toggler v-if="is3d" />
              <map-compass-navigation />
              <v-fade-transition>
                <map-viewmode-toggler @view-mode-changed="switchView" />
              </v-fade-transition>
              <map-locate-button />
              <map-reset-extent-button />
              <map-zoom-navigation v-if="$vuetify.breakpoint.mdAndUp" />
              <map-popup-info-window />
            </v-layout>
          </div>
        </v-fade-transition>
        <div
          v-if="viewloaded"
          v-show="$vuetify.breakpoint.smAndUp"
          style="position: absolute; right: 70px; "
          :class="[
            {
              'controls-bottom-bar-hidden': !tools.coordinates.active,
              'controls-bottom-bar-visible': tools.coordinates.active,
            },
          ]"
        >
          <v-layout style="right: 100px;" row>
            <map-photo-stream-toggler class="mr-2" />
            <map-pan-rotate-toggle-navigation
              v-if="is3d && $vuetify.breakpoint.mdAndUp"
            />
          </v-layout>
        </div>
      </div>

      <v-fade-transition>
        <div
          v-if="viewloaded && tools.coordinates.active"
          style="position: absolute; bottom: 0px; left: 0px; background: #263238; width: 100%; z-index: 10000"
        >
          <map-coordinates
            :map-view="view"
            :elevation-layer="elevLyr"
          ></map-coordinates>
        </div>
      </v-fade-transition>

      <div>
        <map-measure v-if="viewloaded && tools.measure.active" />
      </div>

      <div style="position: absolute; top: 0px; left: 0px;">
        <map-print
          v-if="viewloaded && $vuetify.breakpoint.smAndDown"
          v-show="tools.print.active"
        />
      </div>

      <div style="position: absolute; top: 0px; right: 0px; left: 0px;">
        <v-fade-transition>
          <map-drawing v-if="viewloaded && tools.drawing.active"></map-drawing>
        </v-fade-transition>
      </div>

      <v-fade-transition>
        <div
          v-if="
            tools.print.active &&
              !is3d &&
              typeof this.selectedPrintScale !== 'undefined'
          "
          class="hole"
          style="overflow: hidden"
          :style="{
            width: printRectangle.width + 'px',
            height: printRectangle.height + 'px',
            marginLeft: '-' + printRectangle.width / 2 + 'px',
            marginTop: '-' + printRectangle.height / 2 + 'px',
          }"
        ></div>
      </v-fade-transition>

      <v-layout
        row
        align-center
        justify-center
        v-show="!popupVisible || $vuetify.breakpoint.smAndUp"
        class="pt-2"
        style="position: absolute; height: 30px; padding: 5px; z-index: 2; background: rgba(0,0,0,0.5); width: 100%; bottom: 0px; right: 0px; left: 0px;"
        :class="[
          {
            'controls-bottom-bar-hidden': !tools.coordinates.active,
            'controls-bottom-bar-visible': tools.coordinates.active,
          },
        ]"
      >
        <v-tooltip top class="pr-2">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="connected-to-intranet-signal pr-2"
              v-show="isConnectedToIntranet"
            >
            </span>
          </template>
          <span>Koblet til intranett</span>
        </v-tooltip>
        <span
          v-show="$vuetify.breakpoint.lgAndUp"
          class="pl-1 pr-2"
          style="color: white; font-size: 12px;text-shadow: 1px 1px black;"
        >
          Kartverket, Geovekst og kommuner - Geodata AS | NVEs kartdata
          distribueres i henhold til
          <a href="https://data.norge.no/nlod/no">NLOD</a>.
        </span>
        <div id="scaleBar" style="margin-top: -2px"></div>
        <v-spacer />
        <v-layout row justify-end align-center>
          <v-flex shrink>
            <div
              class="pr-2"
              style="color: white; font-size: 12px;text-shadow: 1px 1px black;"
            >
              <span> EU89 UTM33 {{ pointerCoords }}</span>
              <span
                v-show="$vuetify.breakpoint.smAndUp"
                class="pl-2 mt-0 ml-2 white--text grey darken-3"
                @click="activateTool('coordinates')"
                style="border-radius: 4px; padding: 2px;  cursor: pointer"
                >Koordinatverktøy/moh.
              </span>
            </div>
          </v-flex>

          <map-extent-history-navigation
            class="pl-2"
            v-show="$vuetify.breakpoint.mdAndUp"
            style=""
          />
          <div class="mr-2 ml-2" style="margin-top: -1px;">
            <v-progress-circular
              style=""
              aria-label="Kartet laster"
              v-if="showLoadingBar"
              size="16"
              indeterminate
              color="red"
            ></v-progress-circular>
            <v-progress-circular
              v-else
              aria-label="Kartet er ferdig lastet"
              size="16"
              color="grey darken-2"
              :value="100"
            ></v-progress-circular>
          </div>
        </v-layout>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import MappingMixin from "@/mixins/mappingMixin";
import BasemapMixin from "@/mixins/basemapMixin";
import { mapState, mapActions } from "vuex";
import Vue from "vue";

export default {
  name: "TheMap",

  components: {
    MapMeasure: () => import("@/pages/MapPage/Tools/Measuring/MapMeasure"),
    MapBasemapSelect: () => import("@/pages/MapPage/Map/MapBasemapSelect"),
    MapZoomNavigation: () => import("@/pages/MapPage/Map/MapZoomNavigation"),
    MapPhotoStreamToggler: () =>
      import("@/pages/MapPage/Map/MapPhotoStreamToggler"),
    MapResetExtentButton: () =>
      import("@/pages/MapPage/Map/MapResetExtentButton"),
    MapPrint: () => import("@/pages/MapPage/Tools/Printing/MapPrint"),
    MapCoordinates: () =>
      import("@/pages/MapPage/Tools/Coordinates/MapCoordinates"),
    MapLocateButton: () => import("@/pages/MapPage/Map/MapLocateButton"),
    MapCompassNavigation: () =>
      import("@/pages/MapPage/Map/MapCompassNavigation"),
    MapPanRotateToggleNavigation: () =>
      import("@/pages/MapPage/Map/MapPanRotateToggleNavigation"),
    MapPopupInfoWindow: () => import("@/pages/MapPage/Map/MapPopupInfoWindow"),
    MapViewmodeToggler: () => import("@/pages/MapPage/Map/MapViewmodeToggler"),
    MapBuildingsToggler: () =>
      import("@/pages/MapPage/Map/MapBuildingsToggler"),
    MapDrawing: () => import("@/pages/MapPage/Tools/Drawing/MapDrawing"),
    MapExtentHistoryNavigation: () =>
      import("@/pages/MapPage/Map/MapExtentHistoryNavigation"),
  },
  mixins: [MappingMixin, BasemapMixin],
  data: function() {
    return {
      // map: null,
      // currentView: null,
      sceneView: null,
      // mapView: null,
      elevLyr: null,
      container: "viewDiv",
      viewloaded: false,
      zoom: 5,
      showLoadingBar: false,
      pointerCoords: null,
    };
  },
  computed: {
    ...mapState([
      "coordinatesVisible",
      "popupVisible",
      "sidebarHasOpened",
      "showSideMenu",
      "measureActive",
      "drawingActive",
      "tools",
      "extent",
      "is3d",
      "selectedPageFormat",
      "selectedPrintScale",
      "selectedExtent",
      "mapProfiles",
      "basemaps",
      "selectedBasemap",
      "userSettings",
      "isConnectedToIntranet",
    ]),
    printRectangle() {
      if (this.mapView == null) {
        return {
          width: 100,
          height: 100,
        };
      }

      return {
        width: this.printWidth,
        height: this.printHeight,
      };
    },
    printWidth() {
      if (this.zoom) {
        return (
          (this.selectedPageFormat.width * this.selectedPrintScale.resolution) /
          this.mapView.resolution
        );
      } else {
        return 100;
      }
    },
    printHeight() {
      if (this.zoom) {
        return (
          (this.selectedPageFormat.height *
            this.selectedPrintScale.resolution) /
          this.mapView.resolution
        );
      } else {
        return 100;
      }
    },
  },
  watch: {
    selectedExtent(val) {
      if (val !== null) {
        loadModules(["esri/Graphic"]).then(
          function([Graphic]) {
            this.view.graphics.removeAll();
            let symbol = this.getDefaultHighlightSymbol(this.view, val.type);

            this.view.graphics.add(
              new Graphic({
                geometry: val,
                symbol: symbol,
              })
            );
            this.view.goTo(val);
          }.bind(this)
        );
      }
    },
    "userSettings.sceneViewQualityProfile": function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setSceneViewQualityProfile(newVal);
      }
    },
  },
  methods: {
    ...mapActions([
      "setSceneViewLoaded",
      "activateTool",
      "setTheMap",
      "setZoom",
      "setIs3d",
      "setSnack",
      "setMapLoaded",
      "setShowCatalogue",
      "setShowPredefinedBookmarks",
    ]),
    onDrop(evt) {
      const item = JSON.parse(evt.dataTransfer.getData("mapProfile"));
      this.addMapProfile({
        id: item.id,
        type: item.type,
        showInfoMenu: false,
      });
    },
    createTheMapObject() {
      return new Promise((resolve, reject) => {
        loadModules(["esri/Map", "esri/config", "esri/core/urlUtils"])
          .then(([Map, esriConfig, urlUtils]) => {
            urlUtils.addProxyRule({
              urlPrefix: process.env.VUE_APP_MAP_SAVE_SERVICE_URL,
              proxyUrl: process.env.VUE_APP_PROXY_URL,
            });

            esriConfig.request.proxyUrl = process.env.VUE_APP_PROXY_URL;

            let previouslyChosenBasemap = Vue.$cookies.get("basemap");
            let basemap =
              previouslyChosenBasemap === null
                ? this.basemaps[0]
                : this.basemaps.find((aBasemap) => {
                    return aBasemap.id === previouslyChosenBasemap.id;
                  });

            this.setBasemap(basemap).then((arcgisBasemap) => {
              let theMap = new Map({
                basemap: arcgisBasemap,
              });
              this.setTheMap(theMap);
              resolve(theMap);
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createSceneView() {
      return new Promise((resolve, reject) => {
        loadModules(["esri/views/SceneView", "esri/core/watchUtils"])
          .then(([SceneView, watchUtils]) => {
            this.sceneView = new SceneView({
              map: this.$theMapObject,
              qualityProfile: this.userSettings.sceneViewQualityProfile,
              viewingMode: "local",
              container: null,
            });

            watchUtils.whenFalse(this.sceneView, "stationary", () => {
              this.setShowCatalogue(false);
              if (!this.sceneView.stationary) {
                watchUtils.whenTrueOnce(this.sceneView, "stationary", () => {
                  this.saveExtent(this.sceneView.extent);
                  this.setZoom(this.view.zoom);
                });
              } else {
                watchUtils.whenFalseOnce(this.sceneView, "interacting", () => {
                  this.saveExtent(this.sceneView.extent);
                  this.setZoom(this.view.zoom);
                });
              }
            });

            watchUtils.whenTrue(this.sceneView, "updating", () => {
              if (this.is3d) {
                this.showLoadingBar = true;
              }
            });

            watchUtils.whenFalse(this.sceneView, "updating", () => {
              if (this.is3d) {
                this.showLoadingBar = false;
              }
            });

            this.sceneView.on("pointer-move", (evt) => {
              let convertedCoords = this.view.toMap({ x: evt.x, y: evt.y });
              if (convertedCoords !== null) {
                this.pointerCoords =
                  convertedCoords.y.toFixed() +
                  "N " +
                  " " +
                  convertedCoords.x.toFixed() +
                  "Ø";
              }
            });

            Vue.prototype.$theSceneViewObject = this.sceneView;

            this.sceneView.ui._removeComponents([
              "attribution",
              "zoom",
              "navigation-toggle",
              "compass",
            ]);

            resolve(this.sceneView);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setSceneViewQualityProfile(qualityProfile) {
      if (typeof this.$theSceneViewObject !== "undefined") {
        this.$theSceneViewObject.qualityProfile = qualityProfile;
      }
    },
    switchView(camera) {
      let is3d = this.view.type === "3d";

      let activeViewpoint = this.view.viewpoint.clone();

      this.view.container = null;

      if (is3d) {
        this.mapView.viewpoint = activeViewpoint;
        this.mapView.container = this.container;
        this.view = this.mapView;
        this.setIs3d(false);
        this.enablePopupGeometryHighlight(this.view);
      } else {
        if (this.selectedBasemap.type === "vector") {
          this.setSnack(
            "Vektor bakgrunnskart er ikke ennå tilgjengelig i 3D visning. Vennligst bytt til et annet bakgrunnskart før du fortsetter."
          );
        }
        if (this.sceneView === null) {
          this.createSceneView().then((sceneView) => {
            this.sceneView = sceneView;
            this.setSceneViewLoaded();
            this.sceneView.viewpoint = activeViewpoint;
            this.sceneView.extent = activeViewpoint.extent;
            this.sceneView.container = this.container;
            this.view = this.sceneView;
            if (camera !== undefined) {
              this.sceneView.camera = camera;
            }
            this.enablePopupGeometryHighlight(this.view);
            this.setIs3d(true);
          });
        } else {
          this.sceneView.viewpoint = activeViewpoint;
          this.sceneView.extent = activeViewpoint.extent;
          this.sceneView.container = this.container;
          this.view = this.sceneView;
          this.setIs3d(true);
          if (camera !== undefined) {
            this.sceneView.camera = camera;
          }
          this.enablePopupGeometryHighlight(this.view);
        }
      }

      this.enablePopupGeometryHighlight(this.view);
    },
  },
  created: function() {
    this.$eventHub.$on("switch-to-2d", () => {
      if (this.is3d) {
        this.switchView();
      }
    });
    this.$eventHub.$on("switch-to-3d", (camera) => {
      if (!this.is3d) {
        this.switchView(camera);
      } else {
        if (camera !== undefined) {
          this.sceneView.camera = camera;
        }
      }
    });
  },
  beforeDestroy: function() {
    if (this.sceneView !== null) {
      this.sceneView.destroy();
    }

    if (this.mapView !== null) {
      this.mapView.destroy();
    }
  },
  mounted: function() {
    loadModules([
      "esri/views/MapView",
      "esri/core/watchUtils",
      "esri/layers/ElevationLayer",
      "esri/widgets/ScaleBar",
      "esri/geometry/Extent",
    ]).then(
      function([MapView, watchUtils, ElevationLayer, ScaleBar, Extent]) {
        this.elevLyr = new ElevationLayer({
          url: process.env.VUE_APP_ELEVATION_SERVICE_URL,
        });

        this.createTheMapObject().then((theMap) => {
          theMap.ground.layers.add(this.elevLyr);

          let urlQueries = this.$route.query;
          let extentFromUrl = null;
          if (urlQueries.hasOwnProperty("extent")) {
            let coords = urlQueries.extent.split("|");

            extentFromUrl = {
              xmin: parseInt(coords[0]),
              ymin: parseInt(coords[1]),
              xmax: parseInt(coords[2]),
              ymax: parseInt(coords[3]),
              spatialReference: {
                wkid: 25833,
              },
            };
          }

          let previouslyChosenExtent = Vue.$cookies.get("extent");

          let startExtent =
            extentFromUrl === null
              ? previouslyChosenExtent === null
                ? new Extent(this.extent)
                : previouslyChosenExtent
              : extentFromUrl;

          this.mapView = new MapView({
            map: theMap,
            container: "viewDiv",
            extent: startExtent,
            spatialReference: { wkid: 25833 },
          });

          this.view = this.mapView;

          watchUtils.whenFalse(this.view, "stationary", () => {
            if (!this.view.stationary) {
              watchUtils.whenTrueOnce(this.view, "stationary", () => {
                this.setShowCatalogue(false);
                this.setShowPredefinedBookmarks(false);
                this.saveExtent(this.view.extent);

                this.setZoom(this.view.zoom);
              });
            } else {
              watchUtils.whenFalseOnce(this.view, "interacting", () => {
                this.saveExtent(this.view.extent);
                this.setZoom(this.view.zoom);
              });
            }
          });

          watchUtils.watch(this.view, "zoom", (zoom) => {
            this.zoom = zoom;
          });

          watchUtils.whenTrue(this.view, "updating", () => {
            if (!this.is3d) {
              this.showLoadingBar = true;
            }
          });

          watchUtils.whenFalse(this.view, "updating", () => {
            if (!this.is3d) {
              this.showLoadingBar = false;
            }
          });

          this.view.on("pointer-move", (evt) => {
            let convertedCoords = this.view.toMap({ x: evt.x, y: evt.y });
            if (convertedCoords !== null) {
              this.pointerCoords =
                convertedCoords.y.toFixed() +
                "N " +
                " " +
                convertedCoords.x.toFixed() +
                "Ø";
            }
          });

          new ScaleBar({
            view: this.view,
            unit: "metric",
            container: "scaleBar",
          });

          this.view.when(() => {
            this.$emit("mapview-loaded", this.view);

            this.$emit("map-loaded", theMap);

            this.enablePopupGeometryHighlight(this.view);

            Vue.prototype.$theMapObject = theMap;
            Vue.prototype.$theMapViewObject = this.view;

            this.setMapLoaded();
            this.viewloaded = true;
          });

          this.view.ui._removeComponents(["attribution", "zoom"]);
        });
      }.bind(this)
    );
  },
};
</script>

<style>
h3 {
  margin: 40px 0 0;
}

.basemap-fix {
  margin-left: 55px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: lightskyblue;
}

#viewDiv {
  position: absolute;
  height: 100%;
  right: 0;
}

.sideMenuVisible {
  left: 0px;
}

.sideMenuHidden {
  left: 56px;
}

.bottom-left {
  position: absolute;
  bottom: 0px;
  padding-left: 15px;
  height: 40px;
  left: 0px;
  background: #00000070;
  padding-top: 8px;
  width: 100%;
  font-size: 18px;
}

.image-container {
  position: relative;
  text-align: left;
  color: white;
  margin: 0px;
}

.box {
  position: absolute;
  left: 0px;
  width: 400px;
  height: 100vh;
  overflow: hidden;
}

.transform {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.transform-active {
  background-color: #45cee0;
  height: 105px;
  width: 400px;
}

.test:hover #move-in-to-place {
  right: 0;
  -webkit-transition: all 1s, -webkit-transform 1s;
  transition: all 1s, transform 1s;
  width: 100%;
  height: 100%;
  opacity: 1;
}

.basemap-menu-hidden {
  left: 20px;
}

.basemap-menu-visible {
  left: 20px;
}

.coordinates-menu-hidden {
  left: 56px;
}

.coordinates-menu-visible {
  left: 0px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */

 {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.hide {
  background: transparent;
}

.show {
  background: whitesmoke;
}

.esri-coordinate-conversion {
  background: #00000054;
}

.bottom-bar-visible {
  bottom: 70px;
}

.bottom-bar-hidden {
  bottom: 20px;
}

.controls-bottom-bar-hidden {
  bottom: 50px;
}

.controls-bottom-bar-visible {
  bottom: 100px;
}

.esri-attribution {
  display: none;
}

.hole {
  position: absolute;
  left: 50%;
  border-radius: 5px;
  top: 50%;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}

.map-center-dummy {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.map-corner-dummy {
  position: absolute;
  left: 0%;
  top: 10%;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.map-corner-dummy-drawing {
  position: absolute;
  left: 150px;
  top: 80px;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.esri-ui {
  z-index: 1000;
}

.connected-to-intranet-signal {
  height: 8px;
  margin-left: 5px;
  width: 8px;
  background-color: greenyellow;
  border-radius: 50%;
  display: inline-block;
}
</style>
